<div class="flex flex-row justify-center">
  <mat-card class="portal-prose w-full">
    <mat-card-header>
      <h1 class="portal-page-title">Website Accessibility</h1>
    </mat-card-header>
    <mat-card-content>
      <div class="flex flex-col my-6 gap-4">
        <p class="text-xl">
          Oregon Health Authority Public Health Division is committed to providing all applicants,
          including individuals with disabilities, equal access to web-based information and services.
          We are continually working to improve the web experience on this applicant portal for all registrants.
        </p>

        <hr class="my-4">

        <div class="flex flex-col gap-4">
          <span class="text-lg">
            This website partially conforms with WCAG 2.2 (Levels A and AA).
          </span>
          <span class="text-lg">
            Accessibility updates are in progress to ensure full compliance.
          </span>
          <span class="text-lg">
            If you have any questions, concerns, or suggestions regarding accessibility on this website,
            please contact the HFLC program at the email address below.
          </span>
          <span class="text-lg">
            <a href="mailto:mailbox.hclc@odhsoha.oregon.gov">mailbox.hclc&#64;odhsoha.oregon.gov</a>
          </span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

